<template>
  <div class="info-region-container" style="height:100vh;width:100%" v-allow="'0905'">
    <div class="all-content-container">
      <div class="info-title-container container-user">
        <div class="title_muen">
          <h4>系统消息</h4>
          <!-- <el-button
            type="primary"
            class="adduser"
            @click="add"
            style=" transform: translateY(-8px);"
          >添加</el-button>-->
        </div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="消息类型：" prop="type">
            <!-- <el-input v-model="formInline.user" placeholder="请输入账号"></el-input> -->
            <el-select v-model="formInline.type" placeholder="请选择消息类型">
              <el-option v-for="item in options" :key="item.type" :label="item.name" :value="item.type"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="消息标题：">
            <el-input v-model="formInline.title" clearable placeholder="请输入消息标题" maxlength="20"></el-input>
          </el-form-item>

          <el-form-item label="发送时间：">
            <el-date-picker style="margin-top:4px" v-model="formInline.updateTime" type="daterange" align="right"
              unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
              value-format="yyyy-MM-dd"></el-date-picker>
            <!-- :picker-options="pickerOptions"
    @change="startTime(shop.seller_id, shop.receive_time)"
            -->
          </el-form-item>

          <el-form-item v-allow="'090501'">
            <el-button type="primary" @click="querySystem">查询</el-button>
            <el-button type="button" @click="resetSystem">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="info-content-container">
        <div class="table_content1">
          <el-table :data="tableData" align="center" :header-cell-style="{ background: '#f4f5f7' }" class="data-table">
            <el-table-column align="center" label="序号" width="95">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="type" align="center" label="消息类型"></el-table-column>
            <el-table-column prop="username" align="center" label="接收人" show-overflow-tooltip></el-table-column>
            <el-table-column prop="title" align="center" label="消息标题" show-overflow-tooltip></el-table-column>
            <el-table-column prop="content" align="center" label="消息内容" show-overflow-tooltip></el-table-column>
            <el-table-column prop="updateTime" align="center" label="发送时间" show-overflow-tooltip></el-table-column>
          </el-table>
        </div>
        <div class="pagination-container">
          <div class="page">
            <!-- <p>
              共
              <span class="pagination-info-text">{{ Math.ceil(total/pagesize) }}</span>页
              <span>/</span>
              <span class="pagination-info-text">{{ total }}</span>条数据
            </p>-->
          </div>
          <div class="pagination-content-container">
            <el-pagination background layout="prev, pager, next,jumper" class="pageTap"
              @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pagesize"
              :total="total"></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'systemMessage',
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
        }

      },
      endTime: '9999-11-11',// 结束时间
      startTime: '1949-10-1',//开始时间
      pagesize: 10,
      currentPage: 1,
      total: 0,
      begDate: '',
      endDate: '',

      formInline: {
        type: '',
        title: '',
        updateTime: '',

      },
      options: [
        {
          type: "",
          name: '全部'
        },
        //   {
        //   type:0,
        //   name:'设备消息'
        // },
        {
          type: 1,
          name: '系统公告'
        }
      ],
      modelNoListData: [
        {
          label: '全部',
          id: -1,
        },
        {
          label: '管理员',
          id: 0,
        },
        {
          label: '普通用户',
          id: 1,
        },

      ],
      organizationList: [
        {
          label: '全部',
          id: -1,
        },
        {
          label: '武汉',
          id: 0,
        },
        {
          label: '上海',
          id: 1,
        },
      ],
      tableData: [],

    };



  },

  computed: {},
  created() {
    this.init()
  },
  mounted() {

  },
  methods: {
    // 获取时间
    getDateTime(val) {
      if (val) {
        this.begDate = val[0];
        this.endDate = val[1];
      } else {
        this.begDate = "";
        this.endDate = "";
      }

    },
    init() {
      this.getSystemMessageList()//列表信息
    },
    //查询系统消息列表
    getSystemMessageList() {
      this.$api.system
        .getSystemMessageList(
          this.currentPage,//第几页，默认1
          this.pagesize,//默认展示多少条，默认10
          this.endTime,
          this.startTime,
          this.formInline.title,//标题
          this.formInline.type,//消息类型（0设备消息，1系统公告）
        )

        .then((res) => {
          if (res.code == 200) {
            this.total = res.count
            res.data.forEach((value) => {
              value.type = value.type == 0 ? '设备消息' : '系统公告'
            })
            this.tableData = res.data;
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch((err) => {
          this.$message.info(err)
        })

    },
    //分页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getSystemMessageList()//查询系统消息列表
    },
    //查询
    querySystem() {
      console.log("this.formInline.updateTime", this.formInline.updateTime)

      if (this.formInline.updateTime == '') {
        this.endTime = ''
        this.startTime = ''
      } else if (this.formInline.updateTime == null) {
        this.endTime = ''
        this.startTime = ''
      } else {
        this.endTime = this.formInline.updateTime[1]
        this.startTime = this.formInline.updateTime[0]
      }

      this.getSystemMessageList()

    },
    // 重置
    resetSystem() {
      this.formInline.updateTime = '';
      this.formInline.type = ''
      this.formInline.title = '';
      this.endTime = '9999-11-11';// 结束时间
      this.startTime = '1949-10-1';//开始时间
      this.getSystemMessageList()
    },

    //删除按钮
    del() {
      this.$confirm("是否删除？", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(res => {
          this.$api.system
            .delfun(`/proMaterial/del/${id}`, id)
            .then(res => {
              if (res.code == 200) {
                this.initList();
                this.$message({
                  type: 'success',
                  message: res.msg
                })
              } else {
                this.$message.error(res.msg)
              }
            });

        })
        .catch(() => {
          this.$message.info("已取消删除");
        });

    }




  }
};
</script>

<style >
@import "../../style/systemMessage.scss";

.table_content1 {
  /* width: 101%;
  border: 1px solid rgba(240, 240, 241, 1); */
}
</style>